import React from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  FormFeedback
} from "reactstrap";

const CreateUserModal = props => (
  <Modal
    isOpen={props.modalUser}
    toggle={props.toggleUser}
    backdrop="static"
    className="bastaLang modal-md"
  >
    <ModalHeader toggle={props.toggleUser}>
      {props.isEditMode ? "Edit Support Account" : "Create Support Account"}
    </ModalHeader>

    <ModalBody style={{ backgroundColor: "white" }}>
      <Form onSubmit={props.submitUser}>
        <FormGroup>
          <Label for="exampleText">Email</Label>
          <Input
            type="email"
            name="email"
            onChange={props.handleInputChange}
            rows={10}
            className="form-control input-date-filter remove-bottom-margin"
            value={(props.formData && props.formData.email) || ""}
          />
        </FormGroup>
        <FormGroup>
          <Label for="exampleText">Username</Label>
          <Input
            type="text"
            name="username"
            required={true}
            onChange={props.handleInputChange}
            rows={10}
            className="form-control input-date-filter remove-bottom-margin"
            value={(props.formData && props.formData.username) || ""}
          />
        </FormGroup>
        {!props.isEditMode && (  
        <>
        <FormGroup>
          <Label for="exampleText">Password</Label>
          <Input
            type="password"
            name="password"
            required={true}
            onChange={props.handleInputChange}
            rows={10}
            className="form-control input-date-filter remove-bottom-margin"
          />
        </FormGroup>
        <FormGroup>
          <Label for="exampleText">Confirm Password</Label>
          <Input
            invalid={props.errorPassword}
            type="password"
            className="form-control form-control-lg input-date-filter remove-bottom-margin"
            placeholder="Confirm Password"
            name="confirmpassword"
            onChange={props.handleInputChange}
            rows={10}
          />
          {props.errorPassword && (
            <FormFeedback>Password does not match</FormFeedback>
          )}
        </FormGroup>
         </>
        )}
        <FormGroup>
          <Label for="exampleText">First Name</Label>
          <Input
            type="text"
            name="fname"
            required={true}
            onChange={props.handleInputChange}
            rows={10}
            className="form-control input-date-filter remove-bottom-margin"
            value={(props.formData && props.formData.fname) || ""}
          />
        </FormGroup>
        <FormGroup>
          <Label for="exampleText">Last Name</Label>
          <Input
            type="text"
            name="lname"
            required={true}
            onChange={props.handleInputChange}
            rows={10}
            className="form-control input-date-filter remove-bottom-margin"
            value={(props.formData && props.formData.lname) || ""}
          />
        </FormGroup>
        <FormGroup>
            <Label for="exampleText">Nickname</Label>
            <Input
              type="text"
              name="nickname"
              required={false}
              onChange={props.handleInputChange}
              rows={10}
              className="form-control input-date-filter remove-bottom-margin"
              value={(props.formData && props.formData.nickname) || ""}
            />
          </FormGroup>
        <FormGroup>
          <Label for="exampleText">DOB</Label>
          <Input
            type="date"
            name="bday"
            required={true}
            onChange={props.handleInputChange}
            rows={10}
            className="form-control input-date-filter remove-bottom-margin"
             value={(props.formData && props.formData.bday) || ""}
          />
        </FormGroup>
        <FormGroup>
          <Label for="exampleText">Phone</Label>
          <Input
            type="text"
            name="phone"
            required={true}
            onChange={props.handleInputChange}
            rows={10}
            className="form-control input-date-filter remove-bottom-margin"
            value={(props.formData && props.formData.phone) || ""}
          />
        </FormGroup>
         <FormGroup>
          <Label for="exampleText">Organization</Label>
          <Input
            type="text"
            name="organization"
            required={true}
            onChange={props.handleInputChange}
            rows={10}
            className="form-control input-date-filter remove-bottom-margin"
            value={(props.formData && props.formData.organization) || ""}
          />
        </FormGroup>
        <FormGroup>
          <Label for="exampleText">Home Number</Label>
          <Input
            type="text"
            name="homeNumber"
            onChange={props.handleInputChange}
            rows={10}
            className="form-control input-date-filter remove-bottom-margin"
            value={(props.formData && props.formData.homeNumber) || ""}
          />
        </FormGroup>
        <FormGroup>
          <Label for="exampleText">Work Number</Label>
          <Input
            type="text"
            name="workNumber"
            onChange={props.handleInputChange}
            rows={10}
            className="form-control input-date-filter remove-bottom-margin"
            value={(props.formData && props.formData.workNumber) || ""}
          />
        </FormGroup>
        <FormGroup>
          <Label for="exampleText">Address</Label>
          <Input
            type="text"
            name="address"
            onChange={props.handleInputChange}
            rows={10}
            className="form-control input-date-filter remove-bottom-margin"
            value={(props.formData && props.formData.address) || ""}
          />
        </FormGroup>

        <FormGroup>
          <Label for="exampleText">City</Label>
          <Input
            type="text"
            name="city"
            onChange={props.handleInputChange}
            rows={10}
            className="form-control input-date-filter remove-bottom-margin"
            value={(props.formData && props.formData.city) || ""}
          />
        </FormGroup>
        <FormGroup>
          <Label for="exampleText">State</Label>
          <Input
            type="text"
            name="state"
            onChange={props.handleInputChange}
            rows={10}
            className="form-control input-date-filter remove-bottom-margin"
             value={(props.formData && props.formData.state) || ""}
          />
        </FormGroup>
        <FormGroup>
          <Label for="exampleText">Zip Code</Label>
          <Input
            type="text"
            name="zip"
            onChange={props.handleInputChange}
            rows={10}
            className="form-control input-date-filter remove-bottom-margin"
            value={(props.formData && props.formData.zip) || ""}
          />
        </FormGroup>
        <FormGroup>
          <Label for="exampleText">Height (ft)</Label>
          <Input
            type="text"
            name="height"
            onChange={props.handleInputChange}
            rows={10}
            className="form-control input-date-filter remove-bottom-margin"
            value={(props.formData && props.formData.height) || ""}
          />
        </FormGroup>
        <FormGroup>
          <Label for="exampleText">Weight (lb)</Label>
          <Input
            type="text"
            name="weight"
            onChange={props.handleInputChange}
            rows={10}
            className="form-control input-date-filter remove-bottom-margin"
             value={(props.formData && props.formData.weight) || ""}
          />
        </FormGroup>
        <div className="form-group">
          <label>Gender</label>
          <select
            name="gender"
            className="form-control"
            onChange={props.handleInputChange}
            value={(props.formData && props.formData.gender) || "Male"}
          >
            <option value="Male">Male</option>
            <option value="Female">Female</option>
          </select>
        </div>
        <button type="submit" className="btn btn-block btn-info"
         style={{
            borderRadius: "8px",
            fontWeight: 500,
            fontSize: "16px",
            padding: "10px 18px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
            whiteSpace: "nowrap",
          }}>
          <i
            className={`mdi ${props?.isEditMode ? "mdi-update" : "mdi-content-save"}`}
            style={{ fontSize: "15px", color: "white", marginRight: "5px" }}
          ></i>{props?.isEditMode ? 'UPDATE' : 'SAVE'}
        </button>
      </Form>
    </ModalBody>
  </Modal>
);

export default CreateUserModal;
